<style lang="less">
  @import "./assets/css/common_v1.css";
  @import "./assets/css/reset.css";
  @import "./assets/css/crs.css";
  @import "./assets/css/dianluziliao.css";
  @import "./assets/css/igandChange.css";
  @import './assets/css/jiangtangGG.css';
  @import './assets/css/order.css';
  @import './assets/css/tools.less';
</style>

<template>
  <div style="height: 100%">
    <!-- <transition name="fade"> -->
    <router-view class="view" style="height: 100%;" />
    <!-- </transition> -->
    <!-- 图片浏览组件 -->
    <img-view v-if="$store.state.imgUrl" />
  </div>
</template>

<script type="text/babel">
import imgView from './components/imgView/imgView.vue'
import './assets/font/iconfont.css'

export default {

  components: {
    imgView
  },
  data() {
    return {}
  },

  beforeCreate() {
    if (this._Util.isIOS) {
      this.$store.commit('setFirstUrl', location.href)
    }
    // /v2/epidemicMap 为疫情期间紧急上线功能 要允许未关注人员的使用
    if (window.location.pathname !== '/v2/epidemicMap' && window.location.pathname !== '/kaxiubaodian'&& window.location.pathname !== '/alert/alert') {
      this.$store.dispatch('refreshUserInfo') // 获取当前登录人信息
    }
  },

  created() {
    if (window.android && window.android.getConnectType() === 'decoder-ark') { // 安卓平板打开页面时，getConnectType会返回decoder-ark字段
      localStorage.setItem('isFromMft100', '1')
    }
    const that = this
    setTimeout(function() {
      that._Util.getLocation(that)
    }, 2000)
  },

  mounted() {
    setTimeout(() => {
      this.getToken()
    }, 1000)
    this.$store.commit('judgeIphoneX', this.isIphoneX())
    if (this._Util.isMPaaS()) { // 监听mpass上的退出登录事件
      document.addEventListener('goToLogin', this.loginHandler)
      this.$on('hook:beforeDestroy', () => {
        document.removeEventListener('goToLogin', this.loginHandler)
      })
      if (!this._Util.isMiniApp()) {
        AlipayJSBridge.call('addNotifyListener', { // eslint-disable-line
          name: 'NEBULANOTIFY_MPASS_LOGOUT' // H5 发出的事件必须以 NEBULANOTIFY_ 开通进行监听
        }, (e) => {
          this.$router.push({ name: 'fms' })
          AlipayJSBridge.call('removeNotifyListener', { // eslint-disable-line
            name: 'NEBULANOTIFY_MPASS_LOGOUT'
          })
        })
      }
    }
  },

  methods: {
    /**
     * 监听native方法, 跳转至登录页
     */
    loginHandler() {
      this._Util.mPassRouter({ fullPath: location.origin + '/v2/login?loginPage=loginPage' }, {})
    },
    isIphoneX() {
      let flag = false
      const isIPhoneX = window.devicePixelRatio && window.devicePixelRatio === 3 && window.screen.width === 375 && window.screen.height === 812
      // iPhone XS Max
      const isIPhoneXSMax = window.devicePixelRatio && window.devicePixelRatio === 3 && window.screen.width === 414 && window.screen.height === 896
      // iPhone XR
      const isIPhoneXR = window.devicePixelRatio && window.devicePixelRatio === 2 && window.screen.width === 414 && window.screen.height === 896
      if (/iphone/gi.test(window.navigator.userAgent) && (isIPhoneX || isIPhoneXSMax || isIPhoneXR)) {
        flag = true
      } else {
        flag = false
      }
      return flag
    },
    getToken() {
      const that = this
      if (that._Util.isApp()) {
        api && api.addEventListener({
          name: 'isLogin'
        }, function(ret, err) {
          if (ret && ret.value) {
            // alert('islogin' + JSON.stringify(ret.value.appToken));
            localStorage.setItem('app-token', ret.value.appToken || '')
            // that.$http.defaults.headers['app-token'] = ret.value.appToken;
          }
        })
      } else if (this._Util.isMPaaS()) {
        if (!that._Util.isMiniApp()) {
          AlipayJSBridge.call('addNotifyListener', { // eslint-disable-line
            name: 'NEBULANOTIFY_LOGIN' // H5 发出的事件必须以 NEBULANOTIFY_ 开通进行监听
          }, (e) => {
            this.store.dispatch('refreshUserInfo')
          })
        }
      }
    }
  }
}
</script>
